import { FC, useEffect } from "react";
import { useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import { MuiModal, MuiTypography } from "../..";
import { ClientSearchSaveFilterFormKey } from "../../../pages/clientSearch/modelsAndSchemas/Models";
import { useSearchClientSaveFilterMutation } from "../../../api/services/client/clientApis";
import {
  toggleLoader,
  toggleToast,
} from "../../../redux/slices/appState/appStateSlice";
import { SaveSearchFilterParams } from "../../../api/services/client/models";
import { OverwriteFilterModalWrapper } from "./OverwriteFilter.style";
import { useSiteCore } from "../../../hooks/useSiteCore";
import { filterSiteCoreKeys } from "../siteCore/SiteCoreKeys";

interface ClientSearchFilterProps {
  showModal: boolean;
  handleModalClose: () => void;
  handleSaveNewFilterClick: () => void;
  overrideFilterValues: SaveSearchFilterParams;
  refetchListOfFilters: () => void;
}

export const OverwriteFilterModal: FC<ClientSearchFilterProps> = ({
  showModal,
  handleModalClose,
  handleSaveNewFilterClick,
  overrideFilterValues,
  refetchListOfFilters,
}) => {
  const {
    mutate: postSaveFilter,
    isPending,
    isSuccess,
    isError,
  } = useSearchClientSaveFilterMutation();

  const dispatch = useDispatch();
  const { commonLabels, fetchLabel } = useSiteCore();

  const { setError } = useForm({
    mode: "all",
    defaultValues: {
      [ClientSearchSaveFilterFormKey.filterName]: "",
    },
  });

  const fetchFilterPopupLabel = (key: string) => {
    return fetchLabel(filterSiteCoreKeys.filterPopupKey, key);
  };

  useEffect(() => {
    if (isSuccess) {
      dispatch(
        toggleToast({
          open: true,
          message: fetchFilterPopupLabel(
            filterSiteCoreKeys.overwriteSuccessful,
          ),
        }),
      );
      refetchListOfFilters();
      handleModalClose();
    }
  }, [isSuccess]);

  useEffect(() => {
    dispatch(
      toggleLoader({
        isVisible: isPending,
      }),
    );
    return () => {
      dispatch(toggleLoader({ isVisible: false }));
    };
  }, [isPending]);

  useEffect(() => {
    isError &&
      setError(ClientSearchSaveFilterFormKey.filterName, {
        message: commonLabels.someThingWentWrongPleaseTryAgainLater,
      });
  }, [isError]);

  const handleOverwriteFilterClick = async () => {
    postSaveFilter(overrideFilterValues);
  };

  return (
    <MuiModal
      open={showModal}
      onClose={handleModalClose}
      title={fetchFilterPopupLabel(filterSiteCoreKeys.overwriteFilter)}
      primaryButtonTitle={fetchFilterPopupLabel(filterSiteCoreKeys.overwrite)}
      secondaryButtonTitle={fetchFilterPopupLabel(filterSiteCoreKeys.saveAsNew)}
      tertiaryButtonTitle={commonLabels.cancel}
      onPrimaryButtonClick={handleOverwriteFilterClick}
      onSecondaryButtonClick={handleSaveNewFilterClick}
      onTertiaryButtonClick={handleModalClose}
      disablePrimaryButton={false}
    >
      <OverwriteFilterModalWrapper>
        <MuiTypography
          id="modal-description"
          variant="h3"
          component={"h3"}
          className="confirm-message"
        >
          {fetchFilterPopupLabel(
            filterSiteCoreKeys.overwriteFilterActionMessage,
          )}
        </MuiTypography>
        <MuiTypography variant="h3Bold" component={"h3"} className="item-name">
          {overrideFilterValues.name}
        </MuiTypography>
      </OverwriteFilterModalWrapper>
    </MuiModal>
  );
};
